import {
  COLUMN_EXTRA_LARGE,
  COLUMN_EXTRA_SMALL,
  COLUMN_PRE_MEDIUM,
  PAGE_SIZE_OPTIONS,
} from 'constants/table';
import React, { useEffect, useState } from 'react';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Table, Tag, Segmented } from 'antd';
import { priceRender, renderWithTooltip } from 'utils/table';
import { SumRange } from 'components/Filters/SumRange';
import dayjs from 'dayjs';
import { InputFilter } from 'components/Filters/InputFilter';
import { DatePickerFilter } from 'components/Filters/DatePickerFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';

function AccrualsTable({ dataSource, loading, filters, onFilter, rows }) {
  const [date, setDate] = useState();

  useEffect(() => {
    if (date !== 'all' && date) {
      onFilter({ period: dayjs().month(date).format('MM-YYYY') });
    } else {
      onFilter({ period: null });
    }
  }, [date]);

  const {
    name,
    period,
    f_salary,
    t_salary,
    f_accrual,
    t_accrual,
    f_opv,
    t_opv,
    f_so,
    t_so,
    f_vosms,
    t_vosms,
    f_osms,
    t_osms,
    f_ipn,
    t_ipn,
  } = filters || {};

  function getRoot(name_first) {
    return [
      {
        width: COLUMN_EXTRA_LARGE,
        title: name_first,
        dataIndex: 'name',
        key: 'name',
        render: (value, i) =>
          i.position === 'supervisor' ? (
            <>
              {renderWithTooltip(value)} &nbsp;<Tag>Рук.</Tag>
            </>
          ) : (
            renderWithTooltip(value)
          ),
        filterDropdown: () => {
          return (
            <InputFilter
              value={name}
              placeholder="Поиск по БИН/ИИН"
              onFilterChange={(name) => onFilter({ name })}
            />
          );
        },
        filterIcon: () => <SearchOutlined />,
      },
      {
        width: COLUMN_PRE_MEDIUM,
        title: 'Должность',
        dataIndex: 'custom_position',
        key: 'custom_position',
        render: (i) => i ?? '---',
      },
      {
        width: COLUMN_PRE_MEDIUM,
        title: 'Период',
        dataIndex: 'month',
        key: 'month',
        filterDropdown: () => {
          return (
            <DatePickerFilter
              format="YYYY - MMMM"
              returnFormat="MM-YYYY"
              picker="month"
              value={period}
              getDate={(period) => onFilter({ period })}
            />
          );
        },
        filterIcon: () => <FilterIcon isActive={period} />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'Раб. д',
        dataIndex: 'business_days',
        key: 'business_days',
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'Факт. д',
        dataIndex: 'worker_data',
        key: 'worker_data',
        render: (i) => i.daysCnt ?? '---',
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'Оклад',
        dataIndex: 'worker_data',
        key: 'worker_data',
        render: (i) => priceRender(i.salary),
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_salary}
              toValue={t_salary}
              getRange={(first, second) =>
                onFilter({ f_salary: first, t_salary: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      // {
      //   width: COLUMN_EXTRA_SMALL,
      //   title: 'Факт. оклад',
      //   dataIndex: 'total_salary',
      //   key: 'total_salary',
      //   render: priceRender,
      //   filterDropdown: () => {
      //     return (
      //       <SumRange
      //         fromValue={f_salary}
      //         toValue={t_salary}
      //         getRange={(first, second) =>
      //           onFilter({ f_salary: first, t_salary: second })
      //         }
      //       />
      //     );
      //   },
      //   filterIcon: () => <FilterOutlined />,
      // },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'Доп',
        dataIndex: 'worker_data',
        key: 'worker_data',
        render: (i) => priceRender(i.bonus + i.compensation),
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_salary}
              toValue={t_salary}
              getRange={(first, second) =>
                onFilter({ f_salary: first, t_salary: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'Начислено',
        dataIndex: 'accrual',
        key: 'accrual',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_accrual}
              toValue={t_accrual}
              getRange={(first, second) =>
                onFilter({ f_accrual: first, t_accrual: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'На руки',
        dataIndex: 'total_salary',
        key: 'total_salary',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_salary}
              toValue={t_salary}
              getRange={(first, second) =>
                onFilter({ f_salary: first, t_salary: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'ОПВ (с)',
        dataIndex: 'opv',
        key: 'opv',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_opv}
              toValue={t_opv}
              getRange={(first, second) =>
                onFilter({ f_opv: first, t_opv: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'ОПВР',
        dataIndex: 'opvr',
        key: 'opvr',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_opv}
              toValue={t_opv}
              getRange={(first, second) =>
                onFilter({ f_opvr: first, t_opvr: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'ВОСМС (c)',
        dataIndex: 'vsms',
        key: 'vsms',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_vosms}
              toValue={t_vosms}
              getRange={(first, second) =>
                onFilter({ f_vosms: first, t_vosms: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'ОСМС',
        dataIndex: 'osms',
        key: 'osms',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_osms}
              toValue={t_osms}
              getRange={(first, second) =>
                onFilter({ f_osms: first, t_osms: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'СО',
        dataIndex: 'so',
        key: 'so',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_so}
              toValue={t_so}
              getRange={(first, second) =>
                onFilter({ f_so: first, t_so: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
      {
        width: COLUMN_EXTRA_SMALL,
        title: 'ИПН (с)',
        dataIndex: 'ipn',
        key: 'ipn',
        render: priceRender,
        filterDropdown: () => {
          return (
            <SumRange
              fromValue={f_ipn}
              toValue={t_ipn}
              getRange={(first, second) =>
                onFilter({ f_ipn: first, t_ipn: second })
              }
            />
          );
        },
        filterIcon: () => <FilterOutlined />,
      },
    ];
  }

  const tableColumns = [...getRoot('ФИО')];

  const renderSummary = ({
    salary,
    accruals,
    opv,
    so,
    vosms,
    ipn,
    osms,
    opvr,
  }) => {
    return (
      <Table.Summary.Row style={{ color: 'rgba(0,0,0,0.5)' }}>
        <Table.Summary.Cell>Итого:</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(accruals)}</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(accruals)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(salary)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(opv)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(opvr)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(vosms)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(osms)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(so)}</Table.Summary.Cell>
        <Table.Summary.Cell>{priceRender(ipn)}</Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  return (
    <>
      <Segmented
        options={[
          { label: 'Все', value: 'all' },
          { label: 'Янв', value: '0' },
          { label: 'Фев', value: '1' },
          { label: 'Мар', value: '2' },
          { label: 'Апр', value: '3' },
          { label: 'Май', value: '4' },
          { label: 'Июн', value: '5' },
          { label: 'Июл', value: '6' },
          { label: 'Авг', value: '7' },
          { label: 'Сен', value: '8' },
          { label: 'Окт', value: '9' },
          { label: 'Ноя', value: '10' },
          { label: 'Дек', value: '11' },
        ]}
        onChange={setDate}
        value={date}
        style={{ margin: '4px  0 8px 0' }}
      />

      <Table
        columns={tableColumns}
        dataSource={rows}
        loading={loading}
        scroll={{ x: '2200px' }}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
        }}
        summary={() => renderSummary(dataSource.clientTotals)}
      />
    </>
  );
}

export { AccrualsTable };
